import { flow } from "fp-ts/es6/function"
import { path } from "ramda"

import * as ProfileModel from "./profile.js"
import * as SettingsModel from "./settings.js"

const profile = ProfileModel.domain.selector,
  settings = SettingsModel.domain.selector,
  avatar = flow(settings, path(["settings", "picture"])),
  name = flow(settings, path(["settings", "username"]))

export const selectors = { avatar, profile, settings, name }
